import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

function TermsOfService() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Enable scrolling following the modal scrollbar pattern
  useEffect(() => {
    document.documentElement.classList.add('terms-of-service-page');
    document.body.classList.add('terms-of-service-page');

    return () => {
      document.documentElement.classList.remove('terms-of-service-page');
      document.body.classList.remove('terms-of-service-page');
    };
  }, []);

  return (
    <div className="page-container">
      <header className="header">
        <div className="header-content">
          <Link to="/" className="logo">EFSoft</Link>
          <button 
            className={`burger-menu ${isMenuOpen ? 'open' : ''}`} 
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            <Link to="/" className="nav-link">Home</Link>
          </nav>
        </div>
      </header>
      
          <div className="terms-of-service-modal-body">
        <h1>Terms of Service</h1>
        
        <section>
          <h2>Introduction</h2>
          <p>
            Welcome to EFSoft's Terms of Service. These terms govern your use of our software development services and constitute a legally binding agreement between you and EFSoft.
          </p>
        </section>

        <section>
          <h2>Service Description</h2>
          <p>EFSoft provides:</p>
          <ul>
            <li>Custom web application development</li>
            <li>Software consulting and architecture design</li>
            <li>Healthcare, finance, and e-commerce solutions</li>
            <li>Technical support and maintenance services</li>
          </ul>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have any questions about these Terms, please contact us at: <a href="mailto:support@efsoft.com">support@efsoft.com</a></p>
        </section>
      </div>
    </div>
  );
}

export default TermsOfService;
